import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const ConfiguracaoBoletoList = props => <DefaultDataTable data={props} />;
